import { Image } from "@/components/ui/image/image";

type Props = {
	children: React.ReactNode;
};

export const Island = ({ children }: Props) => {
	return (
		<section className="h-full min-h-screen bg-white">
			<div className="mx-auto flex h-full max-h-screen flex-col items-center justify-center space-y-14 px-4 pb-6 pt-4">
				<div className="w-full space-y-16 rounded-lg pb-6 pt-0  sm:max-w-md sm:pb-8 md:mt-0 lg:min-w-[600px] xl:p-0">
					<div className="flex justify-center px-8 pt-12">
						<Image src="/chillnn-logo-black.png" className="object-contain" width={108} height={108} />
					</div>
					<div className="space-y-4 px-4 md:space-y-6 laptop:px-8">{children}</div>
				</div>
			</div>
		</section>
	);
};
